export default __webpack_public_path__ + "static/domino-logo-large-9a42da9e8670b4b7234319206ad695e6.png";